module.exports = __webpack_public_path__ + "static/media/login-page-banner1.1e47ebc0.png";